import React, { Component } from "react";
import CompanyInfo from "../../../components/CompanyInfo/CompanyInfo";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CardForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina – Se llama al componente Card
================================================================================ */
class CompanyInfoForm extends Component{
    render(){
        return(
            <CompanyInfo/>  
        )   
    }
}

export default CompanyInfoForm;